/* Hide OPFOR announcement bar on scroll — mirrors header scroll behavior */
(function () {
  var bar = document.querySelector(".announcement-bar--opfor");
  if (!bar) return;

  var lastScrollY = window.pageYOffset || 0;
  var isHidden = false;
  var TOP_THRESHOLD = 10;
  var SCROLL_DELTA = 5;

  function getBarHeight() {
    var html = document.documentElement;
    var wasHidden = html.classList.contains("announcement-bar-is-hidden");
    if (wasHidden) {
      html.classList.remove("announcement-bar-is-hidden");
    }
    var height = parseFloat(getComputedStyle(html).getPropertyValue("--bar-h")) || 0;
    if (wasHidden) {
      html.classList.add("announcement-bar-is-hidden");
    }
    return height;
  }

  function syncHeaderTop() {
    var header = document.querySelector("header.hdr") || document.querySelector("header.gh-main-header");
    if (!header) return;
    header.style.top = isHidden ? "0px" : getBarHeight() + "px";
  }

  function showBar() {
    if (!isHidden) return;
    isHidden = false;
    document.documentElement.classList.remove("announcement-bar-is-hidden");
    bar.classList.remove("announcement-bar--hidden");
    syncHeaderTop();
  }

  function hideBar() {
    if (isHidden) return;
    isHidden = true;
    document.documentElement.classList.add("announcement-bar-is-hidden");
    bar.classList.add("announcement-bar--hidden");
    syncHeaderTop();
  }

  function onScroll() {
    var current = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (current <= TOP_THRESHOLD) {
      showBar();
      lastScrollY = current;
      return;
    }

    if (current > lastScrollY + SCROLL_DELTA) {
      hideBar();
    } else if (current < lastScrollY - SCROLL_DELTA) {
      showBar();
    }

    lastScrollY = current;
  }

  window.addEventListener("scroll", onScroll, { passive: true });

  document.addEventListener("mousemove", function (event) {
    if (event.clientY > 40) return;
    if (!isHidden) return;
    if ((window.pageYOffset || 0) <= TOP_THRESHOLD) {
      showBar();
    }
  });

  window.addEventListener(
    "resize",
    function () {
      if (!isHidden) {
        syncHeaderTop();
      }
    },
    { passive: true }
  );

  syncHeaderTop();
  onScroll();
})();
